import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuthContext';
import { api } from '../../api/client';

export default function PortalSetup() {
  const { setPortal, setStatus } = usePortalAuth();
  const nav = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [info, setInfo] = useState(null);
  const [loadErr, setLoadErr] = useState(null);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) { setLoadErr('This invite link is missing its token.'); return; }
    api(`/portal/setup/${encodeURIComponent(token)}`)
      .then(setInfo)
      .catch((e) => setLoadErr(e?.detail || 'This invite link is invalid or has expired.'));
  }, [token]);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) { setError('Use at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords don’t match.'); return; }
    setBusy(true); setError(null);
    try {
      const me = await api('/portal/setup', { method: 'POST', body: { token, password } });
      setPortal(me); setStatus('in');
      nav('/portal', { replace: true });
    } catch (err) { setError(err?.detail || 'Could not finish setup.'); }
    finally { setBusy(false); }
  }

  return (
    <div className="portal-auth">
      <div className="portal-card">
        {loadErr ? (
          <>
            <h1 className="portal-card__title">Invite link problem</h1>
            <p className="form-error">{loadErr}</p>
            <p className="portal-card__sub">Please ask for a new invitation.</p>
          </>
        ) : !info ? (
          <p className="portal-card__sub">Checking your invitation…</p>
        ) : (
          <form onSubmit={submit}>
            <h1 className="portal-card__title">Welcome{info.customer_name ? `, ${info.customer_name}` : ''}</h1>
            <p className="portal-card__sub">
              Set a password for <strong>{info.email}</strong> to access your {info.business_name} portal.
              Using this emailed link confirms your address.
            </p>
            {error && <div className="form-error">{error}</div>}
            <div className="field"><label>Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus required /></div>
            <div className="field"><label>Confirm password</label>
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
            <button className="btn btn--primary btn--block" disabled={busy}>{busy ? 'Setting up…' : 'Create account'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
